import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Breadcrumb from "../components/Breadcrumb";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const EntreOlas = () => {
  const { t } = useTranslation('navigation');
  const { t: tContent } = useTranslation('entreOlas');
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };
  const images = [
    { src: "/images/entre-olas/entre-olas-1.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-2.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-3.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-4.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-5.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-6.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-7.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-8.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-9.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-10.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-11.jpg", aspectRatio: "square" },
    { src: "/images/entre-olas/entre-olas-12.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-13.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-14.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-15.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-16.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-17.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-18.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-19.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-20.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-21.jpg", aspectRatio: "landscape" },
    { src: "/images/entre-olas/entre-olas-22.jpg", aspectRatio: "landscape" },
  ];

  // Conditionally enable navigation on larger screens
  const navigationEnabled = useBreakpointValue({ base: false, md: true });

  return (
    <Box
      maxWidth={{ base: "100%", md: "800px", lg: "1000px" }} // Larger size for bigger pictures
      margin="0 auto"
      padding="20px"
      paddingTop={{ base: "80px", md: "20px" }}
      textAlign="center"
    >
      {/* Breadcrumb */}
      <Box textAlign="left" mb={4}>
        <Breadcrumb 
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.projects'), href: getLocalizedPath('/projects') },
            { label: t('breadcrumbs.entreOlas') }
          ]} 
        />
      </Box>

      {/* Title */}
 

      {/* Swiper Carousel */}
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={10}
        slidesPerView={1}
        style={{
          "--swiper-navigation-color": "black",
          "--swiper-pagination-color": "black",
          width: "100%",
          position: "relative",
        }}
        navigation={navigationEnabled} // Conditionally enable navigation
        pagination={{ clickable: true }}
        className="custom-swiper"
      >
        {images.map(({ src, aspectRatio }, index) => (
          <SwiperSlide key={index}>
            <Box
              m={[0, "50px"]}
              display="flex"
              justifyContent="center"
              alignItems="center"
              height={["420px", "600px"]} // Ensure a consistent height for all slides
              style={{
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Image
                src={src}
                alt={`Entre Olas ${index + 1}`}
                borderRadius="8px"
                loading="lazy"
                style={{
                  width:
                    aspectRatio === "landscape"
                      ? "auto"
                      : aspectRatio === "square"
                      ? "100%"
                      : "100%",
                  height:
                    aspectRatio === "landscape"
                      ? "100%"
                      : aspectRatio === "square"
                      ? "100%"
                      : "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Description */}
      <Box mt="20px">
      <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" mb={5}>
        {tContent('title')}
      </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description1')}
        </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description2')}
        </Text>
      </Box>
    </Box>
  );
};

export default EntreOlas;